import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const CopyIcon16 = (props: SvgProps) => <Svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  {...props}
>
  <Path
    d="M10.6667 11.3346V13.3346C10.6667 13.5114 10.5965 13.681 10.4715 13.806C10.3465 13.9311 10.1769 14.0013 10.0001 14.0013H3.33341C3.1566 14.0013 2.98703 13.9311 2.86201 13.806C2.73699 13.681 2.66675 13.5114 2.66675 13.3346V5.33464C2.66675 5.15782 2.73699 4.98826 2.86201 4.86323C2.98703 4.73821 3.1566 4.66797 3.33341 4.66797H5.33341"
    stroke="#0058AD"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <Path
    d="M12.6666 2H5.99992C5.63173 2 5.33325 2.29848 5.33325 2.66667V10.6667C5.33325 11.0349 5.63173 11.3333 5.99992 11.3333H12.6666C13.0348 11.3333 13.3333 11.0349 13.3333 10.6667V2.66667C13.3333 2.29848 13.0348 2 12.6666 2Z"
    stroke="#0058AD"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</Svg>;

export default CopyIcon16;
